/**
 * Implements a wallet overview section with
 * chain selector, wallet statistics and search input
 */
import {
  IWalletOverview,
  IWalletTradesCountAndVolume,
} from '@kattana-io/common';
import Search from './Search';
import Wallet from './Wallet';
import WalletPlaceholder from './Placeholder';

import './styles.scss';

interface IOverviewProps {
  wallet: IWalletOverview | null;
  tradesAndVolume: IWalletTradesCountAndVolume | null;
  loading: boolean;
  chain?: string;
  address?: string;
}

const Overview = ({
  wallet,
  tradesAndVolume,
  loading,
  chain,
  address,
}: IOverviewProps) => {
  return (
    <div className='overview'>
      <Search chain={chain} address={address} />
      <Wallet
        wallet={wallet}
        tradesAndVolume={tradesAndVolume}
        chain={chain}
        address={address}
        loading={loading}
      />
    </div>
  );
};

export default Overview;
